module.exports = __webpack_public_path__ + "static/img/check1.5b5afcf7.png";